// frontend/src/services/apiService.js
import axios from 'axios';

// Variável para armazenar a função de logout do Contexto (opcional, mas bom manter para limpeza de estado)
let logoutCallback = null;

export const registerLogoutCallback = (callback) => {
  logoutCallback = callback;
};

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

let apiUrl;
if (window.location.hostname.includes('saldoativo.com.br')) {
  apiUrl = 'https://api.saldoativo.com.br';
} else {
  // Dinâmico: Se acessado por IP (ex: 192.168.x.x), usa esse mesmo IP para o backend
  // Se for localhost, usa localhost.
  // Assumindo que o backend roda na porta 8000.
  apiUrl = `http://${window.location.hostname}:8000`;
}

console.log('API Configurada para:', apiUrl);

const api = axios.create({
  baseURL: `${apiUrl}/api/v1`,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    'Content-Type': 'application/json',
    'X-CSRFToken': getCookie('csrftoken')
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Espaço compartilhado: opera os dados do titular selecionado
    const workspaceTitular = localStorage.getItem('workspace_titular');
    if (workspaceTitular) {
      config.headers['X-Workspace-Titular'] = workspaceTitular;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Evita loop infinito se a própria requisição de refresh falhar ou se for a URL de login
    if (originalRequest.url.includes('/auth/token/refresh/') || originalRequest.url.includes('/auth/login/')) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        try {
          const response = await axios.post(`${apiUrl}/api/v1/auth/token/refresh/`, {
            refresh: refreshToken
          });

          if (response.status === 200) {
            const newAccessToken = response.data.access;
            localStorage.setItem('access_token', newAccessToken);

            if (response.data.refresh) {
              localStorage.setItem('refresh_token', response.data.refresh);
            }

            api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

            return api(originalRequest);
          }
        } catch (refreshError) {
          console.error("Sessão expirada. Logout forçado.");

          // 1. Limpeza Crítica
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');

          // 2. Avisa o contexto (se possível)
          if (logoutCallback) {
            logoutCallback();
          }

          // 3. A SOLUÇÃO DEFINITIVA: Força o navegador a ir para o login
          // Só executa se já não estivermos lá para evitar loops estranhos
          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login';
          }

          return Promise.reject(refreshError);
        }
      } else {
        // Não tem refresh token, limpa e redireciona
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');

        if (logoutCallback) logoutCallback();

        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { apiUrl };
export const getAdminUrl = () => `${apiUrl}/admin/`;